import {
  AtSign,
  CreditCard,
  Inbox,
  LayoutDashboard,
  Settings as SettingsIcon,
  Users,
} from 'lucide-react';
import { type ReactNode } from 'react';

import { PATHS } from './paths';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  badgeKey?: 'senders';
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

const iconProps = { size: 18, strokeWidth: 2 } as const;

export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Main',
    items: [
      { to: PATHS.dashboard, label: 'Dashboard', icon: <LayoutDashboard {...iconProps} /> },
      { to: PATHS.aliases, label: 'Aliases', icon: <AtSign {...iconProps} /> },
      { to: PATHS.activity, label: 'Activity', icon: <Inbox {...iconProps} /> },
    ],
  },
  {
    label: 'Manage',
    items: [
      {
        to: PATHS.senders,
        label: 'Senders',
        icon: <Users {...iconProps} />,
        badgeKey: 'senders',
      },
      { to: PATHS.billing, label: 'Billing', icon: <CreditCard {...iconProps} /> },
      { to: PATHS.settings, label: 'Settings', icon: <SettingsIcon {...iconProps} /> },
    ],
  },
];
